import { render, staticRenderFns } from "./ib-pane.vue?vue&type=template&id=af6aad7c&lang=pug&"
import script from "./ib-pane.vue?vue&type=script&lang=js&"
export * from "./ib-pane.vue?vue&type=script&lang=js&"
import style0 from "./ib-pane.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af6aad7c')) {
      api.createRecord('af6aad7c', component.options)
    } else {
      api.reload('af6aad7c', component.options)
    }
    module.hot.accept("./ib-pane.vue?vue&type=template&id=af6aad7c&lang=pug&", function () {
      api.rerender('af6aad7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view/ib-pane.vue"
export default component.exports